import { Component } from "react";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { err: null };
  }
  static getDerivedStateFromError(err) {
    return { err };
  }
  render() {
    if (this.state.err) {
      return (
        <div style={{ padding: 48, fontFamily: "Inter, sans-serif" }}>
          <h1 className="font-serif text-2xl">Something went wrong.</h1>
          <p className="mt-2 text-gray-600">
            Please reload the page. If the issue persists, come back shortly.
          </p>
          <a href="/" className="mt-4 inline-block underline">
            Reload
          </a>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
